<template>
  <div>
    <div class="authForm">
      <div>
        <b-tabs class="authForm__wrapper" fill no-key-nav active-nav-item-class="_white">
          <div class="authForm__label">
            <img v-if="customLogo" :src="customLogo" alt="Tangle" class="authForm__customLogo" />
            <img v-else-if="logoLoaded && !customLogo" src="@/assets/imgs/logo.png" alt="Tangle" />
            <img
              v-if="authInProgress"
              src="@/assets/imgs/gifs/loading.gif"
              class="authForm__inProgress"
              alt="loading"
            />
          </div>
          <b-tab v-if="!isUserAnonymous" title="Login" :active="activeForm === 1">
            <sign-in />
          </b-tab>
          <b-tab title="Register A New Account" :active="activeForm === 2">
            <sign-up />
          </b-tab>
          <div style="display:none" class="authForm__anonymous">
            <b-button variant="success" @click="signInAsAnonymously" v-if="!isUserAnonymous">
              <b>Try it now</b>
            </b-button>
          </div>
        </b-tabs>
      </div>
    </div>
  </div>
</template>

<script>
// components
import SignIn from './SignIn'
import SignUp from './SignUp'
// modules
import { mapState } from 'vuex'
// services
import auth from '@/services/auth'
import db from '@/services/db'

// helpers
import utils from '@/helpers/utils/index.js'

export default {
  components: {
    SignIn,
    SignUp,
  },
  data() {
    return {
      activeForm: 1,
      customLogo: localStorage.getItem('logo'),
      logoLoaded: false,
    }
  },
  computed: {
    ...mapState(['authInProgress', 'isUserAnonymous', 'userId']),
  },
  methods: {
    signInAsAnonymously() {
      this.$store.commit('addProcess', {
        process: 'signIn',
      })
      auth.signInAsAnonymously(err => {
        this.$store.commit('deleteProcess', 'signIn')
        if (err) this.$store.commit('addError', err.message)
        else this.$router.push('/home')
      })
    },
  },
  async created() {
    document.title = 'Log In'

    const lastDash = localStorage.getItem('lastDash')
    if ('-LWDGKf7QhkwDDRqdmIg') this.activeForm = 2

    if (
      !lastDash &&
      document.location.hostname != 'tangleapps.com' &&
      document.location.hostname != 'localhost'
    )
      await utils.checkDomainAssignment(this)

    if (this.$route.path === '/auth/anonymous' && !this.isUserAnonymous) {
      console.log('anon not turned on send user to auth')

      this.$router.push('/auth')
    }

    if (!this.userId && lastDash) {
      await new Promise((resolve, reject) => {
        db.root.ref(`settings/${lastDash}/logoImgSource`).once(
          'value',
          snapshot => {
            const logo = snapshot.val()

            if (logo) {
              this.customLogo = logo
              localStorage.setItem('logo', logo)
            }
            resolve()
          },
          err => {
            reject(err)
          }
        )
      }).catch(err => {
        console.error(err)
      })
    }

    this.logoLoaded = true
  },
}
</script>

<style  lang="scss">
@import '~$scss/globals';
.authForm {
  height: 100vh;
  overflow: auto;
  > div {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
  }
  &__wrapper {
    width: 300px;

  }
  &__label {
    position: relative;
    text-align: center;
    padding: {
      top: 15px;
      bottom: 10px;
    }
    border-bottom: 1px solid $borderColor2;
    margin-bottom: 10px;
    > img {
      max-width: 100%;
      max-height: 100%;
    }
  }
  &__inProgress {
    position: absolute;
    right: -3px;
    top: 76px;
    width: 35px;
    height: 35px;
  }
  .tab-content {
    border: 1px solid $borderColor1;
    background-color: white;
    margin-top: -1px;
    padding: 0 15px 15px 15px;
  }
  &__submit {
    width: 100%;
  }
  &__anonymous {
    padding-top: 10px;
    .btn {
      width: 100%;
    }
  }
  &__customLogo {
    height: 50px;
  }
  .nav-link.active._white {
    background: white;
    border-bottom-color: white;
  }
}
.oauth {
  display: none;
  display: flex;
  margin-bottom: 15px;
  &__link {
    width: 30px;
    height: 30px;
    margin-right: 10px;
    &:last-child {
      margin-right: 0;
    }
  }
}
</style>
